'use client';

import { Flex, SimpleGrid } from '@chakra-ui/react';

import AssistantSurface from '@features/assistant/AssistantSurface';
import { HEDGE_ASSISTANT_CONFIG } from '@features/assistant/modeSuggestions';
import CommodityMarquee from '@features/explore/CommodityMarquee';
import ExploreCommodities from '@features/explore/ExploreCommodities';
import TrendingCommodities from '@features/explore/TrendingCommodities';
import { useHref } from 'hooks/useHref';

const ExploreCommoditiesPage = () => {
  const { commodityHref } = useHref();

  return (
    <AssistantSurface config={HEDGE_ASSISTANT_CONFIG}>
      <Flex direction="column" gap={4} p={4}>
        <CommodityMarquee commodityHref={commodityHref} />
        <ExploreCommodities category="agriculture" commodityHref={commodityHref} />
        <ExploreCommodities category="construction" commodityHref={commodityHref} />
        <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
          <TrendingCommodities commodityHref={commodityHref} />
        </SimpleGrid>
      </Flex>
    </AssistantSurface>
  );
};

export default ExploreCommoditiesPage;
